import { Page } from '@components/common/Page';
import { Center } from '@mantine/core';
import { type FC, type PropsWithChildren } from 'react';

type Props = {
    title?: string;
    backgroundColor?: string;
};

const AuthLayout: FC<PropsWithChildren<Props>> = ({
    title,
    backgroundColor,
    children,
}) => {
    return (
        <Page
            title={title}
            backgroundColor={backgroundColor ?? 'rgb(var(--color-gray-200))'}
            withPadding={false}
        >
            <Center className="flex h-screen w-full items-center justify-center">
                {children}
            </Center>
        </Page>
    );
};

export default AuthLayout;
